import useTranslation from "../../common/translations";
import ResultItem from "./ResultItem";
import ResultSection from "./ResultSection";
import React from "react";
export default function RecentList({ items, onClear, onSelectItem, }) {
    const { t } = useTranslation("site-search");
    if (!items.length)
        return null;
    return (<div>
      <ResultSection title={t("recent.section_title")} action={<button type="button" className="text-sm font-semibold text-[#0071CE]" onClick={onClear}>
            {t("recent.clear")}
          </button>}/>
      <div className="mt-4 space-y-4">
        {items.map((r) => (<ResultItem key={`${r.type}:${r.url}`} item={r} onSelect={onSelectItem}/>))}
      </div>
    </div>);
}
